import { render } from "./ProductGallerySkeleton.vue?vue&type=template&id=7c645243"
import script from "./ProductGallerySkeleton.vue?vue&type=script&lang=js"
export * from "./ProductGallerySkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__